import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Howl } from 'howler';
import Row from '../../../../core/layout/Row';
import Button from '../../../../core/form/Button';
import Separator from '../../../../core/layout/Separator';
import { get } from 'lodash';

const Modes = Object.freeze({
  DEFAULT: 'default',
  LINK: 'link',
});

const NativeSpeechSlice = (props) => {
  const soundRef = useRef();

  const generateSpeechRecognitionSprites = (source) =>
    source.reduce(
      (acc, wordScore, index) => ({
        ...acc,
        [`sprite_${index}`]: [
          wordScore.audioStartTime * 10 - 0.3,
          (wordScore.audioEndTime - wordScore.audioStartTime) * 10 + 0.3,
        ],
      }),
      {}
    );

  const togglePlay = useCallback((index) => {
    if (soundRef.current && !soundRef.current.playing(`sprite_${index}`)) {
      soundRef.current.play(`sprite_${index}`);
    }
  }, []);

  useEffect(() => {
    if (
      props.values.nativeSpeechRecognition &&
      props.values.nativeSpeechRecognition.wordScoreList &&
      get(props.values, props.audioPath, undefined) &&
      typeof get(props.values, props.audioPath, undefined) === 'string'
    ) {
      if (soundRef.current) {
        soundRef.current.unload();
      }
      soundRef.current = new Howl({
        src: [`${process.env.REACT_APP_FILES_URL}/${get(props.values, props.audioPath, undefined)}`],
        autoplay: false,
        preload: true,
        loop: false,
        html5: true,
        volume: 1,
        sprite: generateSpeechRecognitionSprites(props.values.nativeSpeechRecognition.wordScoreList),
      });
    }
    return () => {
      if (soundRef.current) {
        soundRef.current.unload();
      }
    };
  }, [props]);

  if (
    !get(props.values, props.audioPath, undefined) ||
    typeof get(props.values, props.audioPath, undefined) !== 'string'
  ) {
    return null;
  }

  return (
    <Row>
      {props.values.nativeSpeechRecognition && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          {props.values.nativeSpeechRecognition.wordScoreList.map((item, index) => (
            <div
              key={item.audioStartTime}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: '0px 10px 0px 0px',
              }}
            >
              {Modes.DEFAULT === props.mode && (
                <>
                  <small>{item.word}</small>
                  <Button tooltip="Play/Pause" onClick={() => togglePlay(index)} icon={'caret-right'} />
                </>
              )}
              {Modes.LINK === props.mode && (
                <span
                  style={{ textDecoration: 'underline', color: '#1890ff', cursor: 'pointer' }}
                  onClick={() => togglePlay(index)}
                >
                  {item.word}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
      {!!props.onRefreshNativeSpeechRecognition && (
        <>
          <Separator size="xs" />
          <Button
            icon="reload"
            disabled={props.disabled || props.submitting}
            label="Refresh Native Slice"
            onClick={props.onRefreshNativeSpeechRecognition}
          />
        </>
      )}
    </Row>
  );
};

NativeSpeechSlice.propTypes = {
  onRefreshNativeSpeechRecognition: PropTypes.func,
  values: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  audioPath: PropTypes.string,
  mode: PropTypes.oneOf([Modes.DEFAULT, Modes.LINK]),
};

NativeSpeechSlice.defaultProps = {
  values: null,
  submitting: false,
  disabled: false,
  audioPath: 'audio',
  mode: Modes.DEFAULT,
};

export default NativeSpeechSlice;

export { Modes };
